import React, { useState, useEffect } from "react";
import secureLocalStorage from "react-secure-storage";
import {
  Col,
  Row,
  Spin,
  notification,
  Popconfirm,
  Button,
  Card,
  Tooltip,
  Modal,
  Form,
  Input,
} from "antd";
import {
  FileSearchOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";

import "./style.css";
import myCommonApiCall from "../../Common/apicalls";
import hostURL from "../../Common/constants";
import { allCoverTypes, allPriorities } from "../../Common/constants";

import { useDispatch } from "react-redux";
import {
  setSelectedState,
  setSelectedCounty,
  setLandCoverSelections,
  setPrioritySelections,
  setRankingScore,
} from "../../Redux/filterSlice";
import { useNavigate } from "react-router-dom";
import { setStartedFromSavedPriorities } from "../../Redux/wizardSlice";
import { endSession } from "../../Redux/sessionSlice";

const authToken = secureLocalStorage.getItem("token");
const userId = secureLocalStorage.getItem("userRef");

function PastActivity() {
  const [loading, setLoading] = useState(false);
  const [pastSearches, setPastSearches] = useState(false);
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [toUpdatedRecordId, setToUpdatedRecordId] = useState(null);
  const [updatedRecordNameModalOpen, setupdatedRecordNameModalOpen] =
    useState(false);

  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type, title, message) => {
    api[type]({
      message: title,
      description: message,
    });
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getSavedSearchData = () => {
    fetch(hostURL + "api/usersearchdata/" + userId, {
      // credentials: 'include',
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: authToken,
      },
    })
      .then((response) => {
        return new Promise((resolve) =>
          response.json().then((json) => {
            resolve({
              status: response.status,
              ok: response.ok,
              json,
            });
          })
        );
      })
      .then(({ status, json, ok }) => {
        const message = json.message;

        if (status === 200) {
          const itemsData = json.map((item) => {
            const formData = JSON.parse(item.formData);
            // const checkedOptions =  (formData.landCoverSelections)? ((formData.landCoverSelections).concat(formData.prioritySelections)).join(', '): '';
            // const childrenData = `<div>Selected State: <b>${
            //   formData.selectedState
            // }</b>, Selected County: <b>${formData.selectedCounty}</b> <br /></div><div> Selected Options : ${checkedOptions} <br /></div>`;
            return {
              key: item.id,
              route: item.route,
              subroute: item.subRoute,
              searchedData: formData,
              mySearchName: item.mySearchName,
              searchedon: item.createdAt,
              stype: item.stype,
            };
          });
          console.log(itemsData, "itemsData");
          setPastSearches(itemsData);
          setLoading(false);
        } else if (status === 401) {
          myCommonApiCall.signOut();
          dispatch(endSession());
        }
        else openNotificationWithIcon("error", "Error", message);
      });
  };

  useEffect(() => {
    setLoading(true);
    getSavedSearchData();
  }, []);

  // const rowSelection = {
  //   type: "radio",
  //   onSelect: (record) => {
  //     setIsRowSelected(true);
  //     setSelectedRecord(record);
  //     window.sessionStorage.setItem(
  //       "pastSearchData",
  //       JSON.stringify(record.searchedData)
  //     );
  //   },
  // };

  const changeSavedRecordName = (values) => {
    setLoading(true);

    fetch(
      `${hostURL}api/usersearchdata/changeSearchRecordName/${toUpdatedRecordId}`,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: authToken,
        },
        body: JSON.stringify({ recordName: values.nrcsavedName }),
      }
    )
      .then((response) => response.json())
      .then((json) => {
        if (json.message === "Saved search Name was Updated successfully!") {
          getSavedSearchData();
          openNotificationWithIcon(
            "success",
            "Success",
            "Record updated successfully."
          );
        } else {
          openNotificationWithIcon("error", "Error", json.message);
        }
        setLoading(false);
      })
      .catch((error) => {
        openNotificationWithIcon("error", "Error", "Failed to update record.");
        setLoading(false);
      });
    handleUpdateNameModalCancel();
    setToUpdatedRecordId(null);
  };

  const deleteRecord = (recordId) => {
    setLoading(true);
    fetch(`${hostURL}api/usersearchdata/${recordId}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: authToken,
      },
    })
      .then((response) => response.json())
      .then((json) => {
        if (json.message === "Saved search was deleted successfully!") {
          notification.success({
            description: "Removed from Priorities",
            icon: <DeleteOutlined style={{ color: "#faad14" }} />,
          });
          setPastSearches(pastSearches.filter((item) => item.key !== recordId));
        } else {
          openNotificationWithIcon("error", "Error", json.message);
        }
        setLoading(false);
      })
      .catch((error) => {
        openNotificationWithIcon("error", "Error", "Failed to delete record.");
        setLoading(false);
      });
  };

  // const searchAgain = (recordData) => {
  //   if (recordData.stype === "explorePractices") {
  //     window.sessionStorage.setItem(
  //       "pastSearchData",
  //       JSON.stringify(recordData.searchedData)
  //     );
  //     setSelectedRecord({
  //       state: recordData.searchedData.selectedState,
  //       county: recordData.searchedData.selectedCounty,
  //     });
  //     window.location.href = "/practiceList";
  //   } else {
  //     alert("This is not a saved priorities search!");
  //   }
  // };

  const searchAgain = (recordData) => {
    const {
      selectedState,
      selectedCounty,
      landCoverSelections,
      prioritySelections,
      rankingScore,
    } = recordData.searchedData;

    // Hydrate Redux immediately -> No user session middleman
    dispatch(setSelectedState(selectedState));
    dispatch(setSelectedCounty(selectedCounty));
    dispatch(setLandCoverSelections(landCoverSelections));
    dispatch(setPrioritySelections(prioritySelections));
    if (rankingScore) dispatch(setRankingScore(rankingScore));

    // SessionStorage in case it's still needed for something
    window.sessionStorage.setItem(
      "pastSearchData",
      JSON.stringify(recordData.searchedData)
    );
    secureLocalStorage.setItem("IsPastSearch", true);
    dispatch(setStartedFromSavedPriorities(true));
    navigate("/practiceList");
  };

  const DeleteButton = ({ record }) => (
    <>
      <Popconfirm
        title="Are you sure to delete this record?"
        onCancel={(e) => { e.stopPropagation(); }}
        onConfirm={(e) => { e.stopPropagation(); deleteRecord(record.key) }}
        
        okText="Yes"
        cancelText="No"
      >
        <Button type="primary" className="delete-button" onClick={(e) => {  e.stopPropagation() }} danger icon={<DeleteOutlined />} /> 
      </Popconfirm>
      <Popconfirm
        title="Are you sure to Edit the Saved Name?"
        onCancel={(e) => { e.stopPropagation(); }}
        onConfirm={(e) => { e.stopPropagation(); openUpdateNameModal(record.key) }}
        okText="Yes"
        cancelText="No"
      >
        <Button type="primary" onClick={(e) => { e.stopPropagation()}} danger icon={<EditOutlined />} />
      </Popconfirm>
    </>
  );
  const getRankingScoreItems = (rankingData) => {
    let toReturn = "";
    rankingData &&
      rankingData.forEach((item, i) => {
        for (let key in item) {
          toReturn += `<li key=${key + i}>
         ${key}: ${item[key]}</li>`;
        }
      });
    return toReturn;
  };

  const handleUpdateNameModalCancel = () => {
    setupdatedRecordNameModalOpen(false);
  };

  const openUpdateNameModal = (recordId) => {
    setToUpdatedRecordId(recordId);
    setupdatedRecordNameModalOpen(true);
  };

  const onFinishPassFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <Spin spinning={loading}>
        <Row>
          <Col span={20} offset={2}>
            {/* <h3> Past Searches</h3> */}
            {isRowSelected && (
              <Popconfirm
                title="Search Again"
                description="Are you sure to Search Selected Row Data Again ?"
                onConfirm={searchAgain}
                // onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <Button className="filter-button">
                  <b>
                    <FileSearchOutlined /> Search Again
                  </b>
                </Button>
              </Popconfirm>
            )}
          </Col>
        </Row>

        <Row>
          {pastSearches &&
            pastSearches.map((indSearch, index) => {
              const { searchedData } = indSearch;
              if (
                searchedData.selectedState &&
                searchedData.selectedCounty &&
                indSearch.stype === "explorePractices"
              ) {
                return (
                  <Col span={5} offset={1} key={index}>
                    <Card
                      className="saved-search-card"
                      onClick={(e) => {searchAgain(indSearch)}}
                      title={indSearch.mySearchName}
                      extra={<DeleteButton record={indSearch} />}
                    >
                      <div>
                        <ul className="pl5">
                          <li>
                            Selected State:&nbsp;
                            <b>{searchedData.selectedState}</b>
                          </li>
                          <li>
                            Selected County:&nbsp;
                            <b>{searchedData.selectedCounty}</b>
                          </li>

                          <li>
                            Cover Type:
                            <ul className="stepsImages">
                              {allCoverTypes.map(({ value, label, src }) =>
                                searchedData.landCoverSelections?.includes(
                                  value
                                ) ? (
                                  <li key={value}>
                                    <Tooltip placement="topLeft" title={label}>
                                      <img
                                        className="img_selected_cb"
                                        src={src}
                                        alt={value}
                                      />
                                    </Tooltip>
                                  </li>
                                ) : null
                              )}
                            </ul>
                          </li>

                          <li>
                            Priorities:
                            <ul className="stepsImages">
                              {allPriorities.map(({ value, label, src }) =>
                                searchedData.prioritySelections?.includes(
                                  value
                                ) ? (
                                  <li key={value}>
                                    <Tooltip placement="topLeft" title={label}>
                                      <img
                                        className="img_selected_cb"
                                        src={src}
                                        alt={value}
                                      />
                                    </Tooltip>
                                  </li>
                                ) : null
                              )}
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </Card>
                  </Col>
                );
              }
            })}
        </Row>
      </Spin>
      <Modal
        title="Change Saved Search Record Name"
        open={updatedRecordNameModalOpen}
        // onOk={handleOk}
        footer={null}
        onCancel={() => handleUpdateNameModalCancel()}
      >
        <Form
          colon={false}
          layout="horizontal"
          onFinish={changeSavedRecordName}
          onFinishFailed={onFinishPassFailed}
          autoComplete="off"
        >
          <Form.Item
            label="New Record Name"
            name="nrcsavedName"
            rules={[
              {
                required: true,
                message: "Please input your New Record Name!",
                whitespace: false,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item label="&nbsp;">
            <Button type="primary" htmlType="submit" loading={loading}>
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      {contextHolder}
    </>
  );
}
export default PastActivity;
